import { render, staticRenderFns } from "./PersonConfig.vue?vue&type=template&id=4447b497&scoped=true"
import script from "./PersonConfig.vue?vue&type=script&lang=js"
export * from "./PersonConfig.vue?vue&type=script&lang=js"
import style0 from "./PersonConfig.vue?vue&type=style&index=0&id=4447b497&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4447b497",
  null
  
)

export default component.exports